<template>
  <div class="container-fluid">
    <b-card class="card-transparent-background" no-body>
      <b-card-header class="p-0">
        <b-card-body class="py-2">
          <b-row class="mr-0">
            <b-col cols="6" class="pl-0"
              ><b-card-title class="card-title-astrology">{{
                page_title
              }}</b-card-title></b-col
            >
            <b-col cols="6" class="justify-content-end pr-0">
              <b-button
                variant="astrology-danger-no-border"
                id=""
                class="btn btn-bumblebee btn-astrology m-0 p-0 float-right"
                v-b-modal.deleteObjectModal
              >
                Delete Object
              </b-button>
              <!-- delete modal -->
              <DeleteObject client_name="AV" :object_id="object_id" />

            </b-col>
          </b-row>
        </b-card-body>
      </b-card-header>
    </b-card>
    <b-form ref="objectForm" @submit.prevent="onSubmit">
      <b-card no-body class="p-3 mt-3">
        <b-card-body class="pt-0">
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology"
                label="Object type"
                label-for="object_type"
                :object_type="object_type"
                label-class="form-label-astrology"
              >
                <p
                  class="error_validation_message_p_av"
                  v-if="invalid_object_type"
                >
                  Please select object type
                </p>
                <v-select
                  class="v-select-astrology"
                  :options="object_types"
                  :clearable="false"
                  name="object_type"
                  title="object_type"
                  v-model="object_type"
                  :reduce="(item) => item.code"
                  placeholder="Select object type"
                  required
                ></v-select
              ></b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology"
                label="Object name"
                label-for="object_name"
                :object_name="object_name"
                label-class="form-label-astrology"
              >
                <b-form-input
                  id="object_name"
                  class="form-control-admin-astrology"
                  v-model="object_name"
                  :object_name="object_name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology"
                label="Title name"
                label-for="title_name"
                :title_name="title_name"
                label-class="form-label-astrology"
              >
                <b-form-input
                  id="title_name"
                  class="form-control-admin-astrology"
                  v-model="title_name"
                  :title_name="title_name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology"
                label="Description"
                label-for="short_description"
                :short_description="short_description"
                label-class="form-label-astrology"
              >
                <template #label>
                  Description
                  <span class="small-label float-right"
                    >{{ short_description.length }}/{{
                      short_description_max_length
                    }}</span
                  >
                </template>

                <b-form-textarea
                  id="short_description"
                  class="form-control-admin-astrology"
                  v-model="short_description"
                  :short_description="short_description"
                  rows="3"
                  required
                  :maxlength="short_description_max_length"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology"
                label="Long description"
                label-for="long_description"
                :long_description="long_description"
                label-class="form-label-astrology"
              >
                <b-form-textarea
                  id="long_description"
                  class="form-control-admin-astrology"
                  v-model="long_description"
                  :long_description="long_description"
                  rows="6"
                  required
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology"
                label="Additional URL"
                label-for="additional_url"
                :additional_url="additional_url"
                label-class="form-label-astrology"
              >
                <b-form-input
                  id="additional_url"
                  class="form-control-admin-astrology"
                  v-model="additional_url"
                  :additional_url="additional_url"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology form-group-select-astrology"
                label="Tags"
                label-for="tags"
                :tags="tags"
                label-class="form-label-astrology"
              >
                <p class="error_validation_message_p_av" v-if="invalid_tags">
                  Please select tag(s)
                </p>
                <v-select
                  class="v-select-astrology"
                  :options="object_types"
                  :clearable="false"
                  multiple
                  :filterable="true"
                  name="tags"
                  title="tags"
                  v-model="tags"
                  :reduce="(item) => item.label"
                  required
                ></v-select
              ></b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-astrology form-group-upload-files"
                label="Upload files"
                label-for="fileRecords"
                :fileRecords="fileRecords"
                label-class="form-label-astrology"
              >
                <b-list-group
                  v-if="uploadedFiles.length > 0"
                  class="list-group-no-border-astrology"
                >
                  <b-list-group-item
                    v-for="(file, index) in uploadedFiles"
                    :key="file.id"
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      p-0
                      mb-2
                    "
                  >
                    {{ file.file_name }}
                    <b-button
                      variant="action-list-item-astrology "
                      class="btn-delete-action m-0 p-0"
                      @click="deleteFile(file.id, index)"
                    >
                      <font-awesome-icon icon="fa-solid fa-trash-can" />
                      <!-- <img
                      src="@/assets/images/astrology/delete-icon.png"
                      alt="delete icon" /> -->
                    </b-button>
                  </b-list-group-item>
                </b-list-group>
              </b-form-group>
              <VueFileAgent
                id="fileRecords"
                class="upload-files-fileagent-astrology"
                ref="vueFileAgent"
                :theme="'list'"
                :multiple="true"
                :linkable="true"
                :deletable="true"
                :meta="true"
                :helpText="'Choose images, videos or pdf files'"
                :errorText="{
                  type: 'Invalid file type. Only images or zip Allowed',
                  size: 'Files should not exceed 10MB in size',
                }"
                @select="filesSelected($event)"
                @beforedelete="onBeforeDelete($event)"
                @delete="fileDeleted($event)"
                v-model="fileRecords"
              ></VueFileAgent>
              <!-- <button
              :disabled="!fileRecordsForUpload.length"
              @click="uploadFiles()"
            >
              Upload {{ fileRecordsForUpload.length }} files
            </button> -->
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-row class="justify-content-center">
        <b-col lg="3" offset-lg="0" md="4" offset-md="2" sm="6" class="mb-2">
          <b-button
            type="button"
            variant="astrology-danger"
            class="w-100 btn-bumblebee btn-astrology btn-astrology-submit"
            @click="clickCancel"
          >
            Cancel
          </b-button></b-col
        >
        <b-col lg="3" md="4" sm="6" class="mb-2">
          <b-button
            type="button"
            variant="astrology-secondary"
            class="w-100 btn-bumblebee btn-astrology btn-astrology-submit"
            @click="clickSaveDraft"
          >
            Save as draft
          </b-button></b-col
        >
        <b-col lg="3" offset-lg="0" md="4" offset-md="2" sm="6" class="mb-2">
          <b-button
            type="button"
            variant="astrology-info"
            disabled
            class="w-100 btn-bumblebee btn-astrology btn-astrology-submit"
            @click="clickPublishSmiler"
          >
            Publish on smiler
          </b-button></b-col
        >
        <b-col lg="3" md="4" sm="6" class="mb-2">
          <b-button
            type="button"
            variant="astrology-primary"
            class="w-100 btn-bumblebee btn-astrology btn-astrology-submit"
            @click="clickSavePublish"
          >
            Save & Publish
          </b-button>
          <button type="submit" ref="submitObjectBtn" style="display: none">
            Submit
          </button>
        </b-col>
      </b-row></b-form
    >
  </div>
</template>
            

<script>
import $ from "jquery";
import axios from "axios";

import Select2 from "v-select2-component";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import DeleteObject from './DeleteObject.vue'

var table;
export default {
  name: "AstrologyObjectInfo",
  components: { Select2, DeleteObject },
  data() {
    return {
      client_name: "AV",
      page_title: "",

      object_types: [
        { code: "zodiac", label: "Zodiac" },
        { code: "house", label: "House" },
        { code: "planet", label: "Planet" },
        { code: "natal_aspect", label: "Natal aspect" },
        { code: "elements", label: "Elements" },
        { code: "quadrants", label: "Quadrants" },
        { code: "transit_aspect", label: "Transits Aspects" },
      ],
      object_types_tags: [
        "Zodiac",
        "House",
        "Planet",
        "Natal aspect",
        "Elements",
        "Quadrants",
        "Transits Aspects",
      ],
      object_id: null,
      object_type: "",
      invalid_object_type: false,
      object_name: "",
      title_name: "",
      short_description: "",
      short_description_max_length: 150,
      long_description: "",
      additional_url: "",
      tags: null,
      invalid_tags: false,
      fileRecords: [],
      fileRecordsForUpload: [],
      uploadedFiles: [],
      uploadedFilesIDs: [],

      action_type: "",
      action: "",

      swal_confirm_button_class:
        "btn btn-bumblebee btn-astrology  btn-astrology-primary",
      swal_container_class: "swal-container-av",
    };
  },
  mounted() {
    console.log(this.$route.fullPath.includes("add"));
    this.uploadedFilesIDs = [];
    if (this.$route.fullPath.includes("add")) {
      this.page_title = "Add Object";
      this.action = "add";
      this.action_type = "draft";
    } else {
      this.page_title = "Object Info";
      this.action = "update";

      this.getObjectInfo(this.$route.params.id);
    }
  },
  methods: {
    getObjectInfo(id) {
      console.log("in get object info", id);

      this.object_id = id;
      this.object_type = "planet";
      this.object_name = "Planet 1";
      this.title_name = "test title planet 1";
      this.short_description = "test short description";
      this.long_description = "test test test long description";
      this.additional_url = "www.example.com";
      this.tags = ["Planet", "Natal aspects"];
      this.uploadedFiles = [
        {
          id: 1,
          file_name: "img1.png",
          path: "https://microservices-staging.bumblebeeai.io/uploads/images/MinWD55dJowPAWIn2LrxCbLGWVGuFNjoAQXJp7z5.png",
        },
        {
          id: 2,
          file_name: "img2.png",
          path: "https://microservices-staging.bumblebeeai.io/uploads/images/0ktbZgsBsNgrs8LYVd7wBjz5yVyAoodyNZqO8V5B.png",
        },
      ];

      this.uploadedFiles.forEach((item) => {
        this.uploadedFilesIDs.push(item.id);
      });
    },
    clickDeleteObject(id) {
      console.log("Delete object", id);
      this.selected_object_id = id;
      this.$root.$emit("bv::show::modal", "deleteModal");
    },
    clickConfirmDelete() {
      console.log(
        "confirm delete object",
        this.selected_object_id,
        this.client_name
      );
      this.$bvModal.hide("deleteModal");
    },

    closeModalDelete() {
      this.$bvModal.hide("deleteModal");
    },
    clickCancel() {
      console.log("click cancel");
      this.$router.replace({ name: "AstrologyObjectList" });
    },
    clickPublishSmiler() {
      console.log("click publish smiler");
    },
    clickSaveDraft() {
      console.log("click save draft");
      this.action_type = "draft";
      this.$refs.submitObjectBtn.click();
    },
    clickSavePublish() {
      console.log("click save publish");
      this.action_type = "publish";
      this.$refs.submitObjectBtn.click();
    },
    onSubmit(event) {
      console.log(event);
      console.log(this.action_type);
      console.log(this.object_type);
      console.log(this.object_name);
      console.log(this.title_name);
      console.log(this.short_description);
      console.log(this.long_description);
      console.log(this.additional_url);
      console.log(this.tags);
      console.log(this.fileRecords);
      console.log(this.fileRecordsForUpload);
      console.log(this.uploadedFilesIDs);

      if (this.object_type == "" || this.object_type == null) {
        this.invalid_object_type = true;
      } else {
        this.invalid_object_type = false;
      }
      if (this.tags == null || this.tags.length == 0) {
        this.invalid_tags = true;
      } else {
        this.invalid_tags = false;
      }

      if (!this.invalid_object_type && !this.invalid_tags) {
        console.log("validated form - object info");
        if (this.fileRecordsForUpload.length > 0) {
          console.log("found files");
          this.sendFilesRequest();
        } else {
          this.sendSaveRequest();
        }
      } else {
      }
    },
    deleteFile(id, index) {
      console.log("delete file", id, index);
      console.log(this.uploadedFiles);
      this.uploadedFiles.splice(index, 1);
      console.log(this.uploadedFiles);
      let indexID = this.uploadedFilesIDs.indexOf(id);
      console.log(indexID);
      if (indexID != -1) {
        this.uploadedFilesIDs.splice(indexID, 1);
      }
    },
    sendFilesRequest() {
      console.log("send file request ");
      this.sendSaveRequest();
      return;

      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("selectedfile", this.cover_image);

      this.fileRecordsForUpload.forEach((item) => {
        formData.append("selectedfile[]", item.file);
      });
      console.log(formData);
      console.log(formData.get("selectedfile[]"));

      axios
        .post("filesmodule/upload", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          //this.uploadedFilesIDs.puhs(id)
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.error);
          console.log(error.request);
          console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendSaveRequest() {
      console.log("send save request");

      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("object_type", this.object_type);
      formData.append("object_name", this.object_name);
      formData.append("title_name", this.title_name);
      formData.append("short_description", this.short_description);
      formData.append("long_description", this.long_description);
      formData.append("additional_url", this.additional_url);
      this.tags.forEach((item) => {
        formData.append("tags[]", item);
      });
      this.uploadedFilesIDs.forEach((item) => {
        formData.append("files[]", item);
      });

      if (this.action == "add") {
        console.log("submit add object ", this.action_type);
        this.sendAddObjectRequest(formData);
      } else {
        console.log("submit edit object ", this.action_type);
        this.sendUpdateObjectRequest(formData);
      }
    },
    sendAddObjectRequest(formData) {
      console.log("sned add object request");
      this.$fire({
        // title: "Title",
        text: "Object is saved successfully",
        type: "success",
        timer: 3000,
        customClass: {
          container: this.swal_container_class,
          confirmButton: this.swal_confirm_button_class,
        },
      }).then((r) => {
        // console.log(r.value);
      });
      this.$refs.objectForm.reset();
      this.object_type = null;
      this.tags = [];
      this.fileRecords = [];
      this.fileRecordsForUpload = [];
    },
    sendUpdateObjectRequest(formData) {
      console.log("sned edit object request");
      this.$fire({
        // title: "Title",
        text: "Object is updated successfully",
        type: "success",
        timer: 3000,
        customClass: {
          container: this.swal_container_class,
          confirmButton: this.swal_confirm_button_class,
        },
      }).then((r) => {
        // console.log(r.value);
      });
      this.$router.go();
    },

    ////////// file agent functions
    uploadFiles: function () {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
      // this.fileRecordsForUpload = [];
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelected: function (fileRecordsNewlySelected) {
      console.log(fileRecordsNewlySelected);
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      console.log(validFileRecords);
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);
      console.log(this.fileRecordsForUpload);
      console.log(this.fileRecords);
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/astrology_ventures/admin/content_management/ObjectInfo.vue